import Button from "../../../components/atoms/buttons/Button";

interface IProps {
  imageSrc: string;
  title: string;
  description: string;
  // date?: string;
  // type?: "buy" | "notify";
  onAction: () => void;
}

function CoverOverlapCard({ imageSrc, title, description, onAction }: IProps) {
  return (
    <div className="relative h-[390px] w-[380px] rounded-xl border-2 border-white border-opacity-30 bg-primary p-7 text-white">
      <img
        src={imageSrc}
        className="mb-2 h-[100px] w-[100px] rounded-lg border-2 border-white border-opacity-25 object-cover"
        alt={`${title}brand_discover_cover`}
      />
      <span className="w-full font-satoshi text-lg font-bold 2xl:text-[22px]">{title}</span>
      <p className="mt-2 line-clamp-5 w-full font-satoshi text-xxs font-450 opacity-80 2xl:text-xs">{description}</p>
      <div className="absolute bottom-5">
        {/* <p className="font-[satoshi variable] font-semibold text-xl text-[#488AC9]">Sales being on</p>
        <p className="font-[satoshi variable] font-semibold text-xl">
          {`${moment(date).format("MMMM, DD YYYY [at] hh:mma [GMT]")}+ ${moment(date).utcOffset() / 60}`}
        </p> */}
        <Button
          onClick={onAction}
          text="Visit"
          variant="rustPinkSolid"
          additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3 border-white"
        />
      </div>
    </div>
  );
}

export default CoverOverlapCard;
